var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { FormattedMessage, FormattedNumber } from "react-intl";
import moment from "moment";

import messages from "./FormatMetric.messages";

var FormatMetric = (_temp2 = _class = function (_Component) {
    _inherits(FormatMetric, _Component);

    function FormatMetric() {
        var _temp, _this, _ret;

        _classCallCheck(this, FormatMetric);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.formatInteger = function () {
            var value = _this.props.value;


            if (_this.context.intl) {
                return React.createElement(FormattedNumber, { value: value });
            }

            value = new Intl.NumberFormat('de-DE').format(value);

            return value;
        }, _this.formatFloat = function () {
            var _this$props = _this.props,
                value = _this$props.value,
                decimals = _this$props.decimals;


            if (_this.context.intl) {
                return React.createElement(FormattedNumber, { value: value, minimumFractionDigits: 2, maximumFractionDigits: decimals });
            }

            value = parseFloat(value).toFixed(decimals);
            value = new Intl.NumberFormat('de-DE').format(value);

            return value;
        }, _this.formatPercent = function () {
            var _this$props2 = _this.props,
                value = _this$props2.value,
                decimals = _this$props2.decimals;

            /*
                
            if (this.context.intl) {
                return (
                    <FormattedNumber value={parseFloat(value/100)} style="percent" minimumFractionDigits={decimals} maximumFractionDigits={decimals} />
                )
            }
            
            */

            value = parseFloat(value).toFixed(decimals) + "%";

            return value;
        }, _this.formatTime = function () {
            var value = _this.props.value;


            value = moment().startOf('day').add(value, "seconds").format('HH:mm:ss');

            return value;
        }, _this.formatDuration = function () {
            var value = _this.props.value;


            var sec_num = parseInt(value, 10);

            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - hours * 3600) / 60);
            var seconds = sec_num - hours * 3600 - minutes * 60;

            if (hours) {
                return hours + 'h ' + minutes + 'm ' + seconds + 's';
            }

            if (minutes) {
                return minutes + 'm ' + seconds + 's';
            }

            return seconds + 's';
        }, _this.formatValue = function () {
            var _this$props3 = _this.props,
                type = _this$props3.type,
                value = _this$props3.value,
                decimals = _this$props3.decimals;


            if (type === "INTEGER") {
                return _this.formatInteger();
            }

            if (type === "FLOAT") {
                return _this.formatFloat();
            }

            if (type === "PERCENT") {
                return _this.formatPercent();
            }

            if (type === "TIME") {
                return _this.formatTime();
            }

            if (type === "DURATION") {
                return _this.formatDuration();
            }

            return value;
        }, _this.formatName = function () {
            var name = _this.props.name;


            if (messages[name]) {
                return React.createElement(FormattedMessage, messages[name]);
            }

            return name;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    FormatMetric.prototype.render = function render() {
        var _props = this.props,
            name = _props.name,
            type = _props.type,
            value = _props.value;


        if (value) {
            return this.formatValue();
        }

        if (name) {
            return this.formatName();
        }

        return null;
    };

    return FormatMetric;
}(Component), _class.contextTypes = { intl: PropTypes.object }, _class.defaultProps = {
    decimals: 2
}, _temp2);
FormatMetric.propTypes = process.env.NODE_ENV !== "production" ? {
    name: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.number,
    decimals: PropTypes.number
} : {};


export default FormatMetric;